// extracted by mini-css-extract-plugin
export default {"icon":"Connect_icon__DAJSL","info":"Connect_info__Tvhi8","button":"Connect_button__vPyOn"};